var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"feather feather-chevron-right",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"1","stroke-linecap":"round","stroke-linejoin":"round"},on:{"click":_vm.onClick}},[_c('polyline',{attrs:{"points":"9 18 15 12 9 6"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }